import { axios } from './config';

export const getAllRssVideoJobs = (siteId) => {
	return axios.get(`/rss-video-generation/jobs?siteId=${siteId}`);
};

export const createRssVideoJob = (payload) => {
	return axios.post('/rss-video-generation/jobs', payload);
};

export const getRssVideoJob = (jobId) => {
	return axios.get(`/rss-video-generation/jobs/${jobId}`);
};

export const cancelRssVideoJob = (jobId) => {
	return axios.post(`/rss-video-generation/jobs/${jobId}/cancel`);
};

export const retryRssVideoJob = (jobId) => {
	return axios.post(`/rss-video-generation/jobs/${jobId}/retry`);
};

export const updateRssVideoJobMetadata = (jobId, payload) => {
	return axios.patch(`/rss-video-generation/jobs/${jobId}`, payload);
};

export const hardResetRssVideoJob = (jobId) => {
	return axios.post(`/rss-video-generation/jobs/${jobId}/hard-reset`);
};

export const deleteRssVideoJob = (jobId) => {
	return axios.delete(`/rss-video-generation/jobs/${jobId}`);
};

export const createRssVideoFeed = (payload) => {
	return axios.post('/rss-video-generation/feeds', payload);
};

export const getRssVideoFeed = (siteId) => {
	return axios.get(`/rss-video-generation/feeds/${siteId}`);
};

export const updateRssVideoFeed = (siteId, payload) => {
	return axios.patch(`/rss-video-generation/feeds/${siteId}`, payload);
};

export const deleteRssVideoFeed = (siteId) => {
	return axios.delete(`/rss-video-generation/feeds/${siteId}`);
};

export const pollRssVideoFeed = (siteId) => {
	return axios.post(`/rss-video-generation/feeds/${siteId}/poll`);
};
